import _ from 'lodash'
import type React from 'react'
import { forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'

const dateTypes = ['date', 'datetime-local', 'month', 'time', 'week']
type DateType = (typeof dateTypes)[number]
type Props = {
  id?: string
  className?: string
  prepend?: string | React.ReactNode
  addon?: string | React.ReactNode
  inline?: boolean
  compact?: boolean
  label?: string | React.ReactNode
  name: string
  value?: string | number | undefined
  placeholder?: string
  maxLength?: number
  type?: 'email' | 'numeric' | 'password' | 'search' | 'tel' | 'text' | 'url' | DateType | undefined
  disabled?: boolean
  optional?: boolean
} & React.ComponentPropsWithoutRef<'input'>

export const Text = forwardRef<HTMLInputElement, Props>((props: Props, ref: React.Ref<HTMLInputElement>) => {
  const {
    inline,
    compact,
    className,
    label,
    id,
    name,
    type,
    value,
    placeholder,
    maxLength,
    disabled,
    optional,
    prepend,
    addon,
    onChange,
    onBlur,
    onFocus,
  } = props
  const errMsg = _.get(props, 'data-error')
  return (
    <div className={twMerge(inline ? '' : 'w-full')}>
      {label && (
        <label htmlFor={id || name} className='form-label'>
          {label}
          {optional && <span className='ml-1.5 font-light text-zinc-600 dark:text-zinc-400'>(optional)</span>}
        </label>
      )}
      <div className={twMerge('form-container', inline ? 'mt-0' : 'mt-1', disabled && 'form-disabled')}>
        {prepend && <div className='form-prepend'>{prepend}</div>}
        <input
          autoComplete='off'
          ref={ref}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          id={id || name}
          name={name}
          value={value}
          type={type || 'text'}
          inputMode={type === 'email' || type === 'numeric' || type === 'search' || type === 'tel' || type === 'url' ? type : 'text'}
          placeholder={placeholder || ''}
          maxLength={maxLength || undefined}
          disabled={disabled}
          aria-label={props['aria-label'] || (typeof label === 'string' ? label : name)}
          aria-invalid={!!errMsg}
          aria-errormessage={errMsg ? `${id || name}-error` : undefined}
          className={twMerge('form-input', compact && 'md:h-9!', className)}
        />
        {addon && <div className='form-addon'>{addon}</div>}
      </div>
      {errMsg && (
        <div id={`${id || name}-error`} className='form-error-message' role='alert'>
          {errMsg}
        </div>
      )}
    </div>
  )
})
